const styles = (theme) => ({
  container: {
    [theme.breakpoints.up('md')]: {
      height: 'calc(100vh - 80px)',
      display: 'flex',
    },
  },
  filterContainer: {
    [theme.breakpoints.up('md')]: {
      borderRight: '1px solid',
      borderColor: 'divider',
      p: 2,
      height: '100%',
      overflowY: 'auto',
    },
  },
  contentContainer: {
    [theme.breakpoints.up('md')]: {
      flex: 1,
      height: '100%',
      overflowY: 'auto',
      p: 2,
    },
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: '100%',
  },
  formButton: {
    alignSelf: 'center',
  },
  table: {
    backgroundColor: '#f5f5f5',
  },
});

export default styles;
